import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import i18next from 'i18next';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Canonical document type mapping based on backend enums (libs/common/src/constants/types/index.ts)
export type DocumentTypeCode =
  | 'INVOICE'
  | 'BANK_STATEMENT'
  | 'PAYSLIP'
  | 'FINANCIAL_STATEMENT'
  | 'TAX_FORM'
  | 'CONTRACT'
  | 'CHECK'
  | 'PURCHASE_ORDER'
  | 'TPS_TVQ'
  | 'T4_SLIPS'
  | 'R1_SLIPS'
  | 'LAW_TEXT_OR_PRESS_RELEASE'
  | 'OTHER';

export function toFrDocTypeLabel(value?: string): string {
  const key = (normalizeDocumentTypeCode(value) || 'OTHER') as DocumentTypeCode;
  const translated = i18next.t?.(`docType.${key}`);
  return translated && translated !== `docType.${key}` ? translated : value || 'OTHER';
}

export function normalizeDocumentTypeCode(value?: string): DocumentTypeCode {
  const raw = (value || 'OTHER').toString().trim().toUpperCase();
  // Remove quotes, backticks and spaces
  let code = raw.replace(/[`'"\s]/g, '');
  // Remove any non A-Z, 0-9, or underscore
  code = code.replace(/[^A-Z0-9_]/g, '');
  // Fix common missing underscores
  if (code === 'BANKSTATEMENT') code = 'BANK_STATEMENT';
  if (code === 'FINANCIALSTATEMENT') code = 'FINANCIAL_STATEMENT';
  if (code === 'T4SLIPS') code = 'T4_SLIPS';
  if (code === 'R1SLIPS') code = 'R1_SLIPS';
  if (code === 'LAWTEXTORPRESSRELEASE') code = 'LAW_TEXT_OR_PRESS_RELEASE';
  if (
    [
      'INVOICE',
      'BANK_STATEMENT',
      'PAYSLIP',
      'FINANCIAL_STATEMENT',
      'TAX_FORM',
      'CONTRACT',
      'CHECK',
      'PURCHASE_ORDER',
      'TPS_TVQ',
      'T4_SLIPS',
      'R1_SLIPS',
      'LAW_TEXT_OR_PRESS_RELEASE',
      'OTHER',
    ].includes(code)
  ) {
    return code as DocumentTypeCode;
  }
  return 'OTHER';
}
